export default __webpack_public_path__ + "static/media/hht2_ep18_timeline_q04_a.91460912.png";